import swal from 'sweetalert2';

let confirmationDialogs = document.querySelectorAll('.is-destructive');

[].forEach.call(confirmationDialogs, el => {
  el.addEventListener('click', (evt) => {
    evt.preventDefault();
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#00d1b2',
      cancelButtonColor: '#ff3860',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {
        el.closest('form').submit();
      }
    })
  });
});



// WEBPACK FOOTER //
// ./resources/assets/website/scripts/confirm-dialog.js